export const NEW_VEHICLE_MAX_DAYS_ON_STOCK = 5;
